import React, { useContext } from 'react';
import { LanguageContext } from './LanguageContext';
import './Footer.css';
import { FaWhatsapp, FaMailBulk, FaLinkedin } from 'react-icons/fa';

function Footer() {
  const { language } = useContext(LanguageContext);

  return (
    <footer className="footer">
      <div className="container text-center">
        <p>
          &copy; {new Date().getFullYear()} Tacosoft. {language === 'en' ? 'All rights reserved.' : 'Tüm hakları saklıdır.'}
        </p>
        <ul className="footer-links">
          <li><a href="/about">{language === 'en' ? 'About Us' : 'Hakkımızda'}</a></li>
          <li><a href="/privacy-policy">{language === 'en' ? 'Privacy Policy' : 'Gizlilik Politikası'}</a></li>
          <li><a href="/contact">{language === 'en' ? 'Contact' : 'İletişim'}</a></li>
        </ul>
        <div className="social-icons">
          <a 
            href="https://wa.me/905326330097" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            <FaWhatsapp />
          </a>
          <a href="mailto:sinanakyol@tacosoft.com.tr?subject=Hello&body=I%20am%20reaching%20out%20to%20you..." 
            target="_blank" 
            rel="noopener noreferrer"><FaMailBulk /></a>
          <a href="https://www.linkedin.com/company/tacosoft/posts/?feedView=all" target="_blank" rel="noopener noreferrer"><FaLinkedin /></a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
